export default "__VITE_ASSET__DW5DWbUe__"